import apiClient, { extractData } from '../api-client';

export const settingsApi = {
  get() {
    return apiClient.get('/settings').then(extractData);
  },
  update(data) {
    return apiClient.patch('/settings', data).then(extractData);
  },
  // QR chuyển khoản (data URL base64) theo mã đơn — sinh phía server, nội dung CK có mã đơn.
  // Trả null nếu chưa cấu hình ngân hàng hoặc tải QR thất bại.
  getPaymentQr(orderCode = '') {
    return apiClient
      .get('/settings/payment-qr', { params: { order_code: orderCode } })
      .then(extractData)
      .then((d) => d?.qr_base64 ?? null);
  },

  // Đã khai khoá gọi tổng / bí mật webhook chưa — KHÔNG trả giá trị thật.
  centralKeyStatus() {
    return apiClient.get('/settings/central-key/status').then(extractData);
  },

  // Khai/đổi khoá gọi tổng. Backend TEST KẾT NỐI trước khi lưu — sai khoá thì
  // request này fail, khoá cũ (nếu có) vẫn còn nguyên.
  updateCentralKey(centralApiKey) {
    return apiClient
      .patch('/settings/central-key', { central_api_key: centralApiKey })
      .then(extractData);
  },

  // Khai/đổi bí mật ký webhook (tổng gọi VỀ). Không test được — lưu thẳng.
  updateWebhookSecret(webhookSecret) {
    return apiClient
      .patch('/settings/webhook-secret', { webhook_secret: webhookSecret })
      .then(extractData);
  },

  // Hiện đầy đủ khoá/bí mật — backend bắt gõ lại mật khẩu đăng nhập, 401 nếu sai.
  revealCentralKey(password) {
    return apiClient.post('/settings/central-key/reveal', { password }).then(extractData);
  },
  revealWebhookSecret(password) {
    return apiClient.post('/settings/webhook-secret/reveal', { password }).then(extractData);
  },
};
